import React from 'react';
import { Telematics } from 'types/IEquipmentEntry';
import InMotionIcon from 'assets/images/in_motion.svg';
import InTransportIcon from 'assets/images/in_transport.svg';
import ParkingIcon from 'assets/images/parking.svg';

interface Props {
  telematics: Telematics;
}

export default function InMotionStatusIcon({ telematics }: Props) {
  const { engineRunning, motionState } = telematics;

  if (engineRunning && motionState === 'moving') {
    return <img src={InMotionIcon} alt="In Motion" />;
  }

  if (
    (!engineRunning && motionState === 'moving') ||
    motionState === 'in-transport'
  ) {
    return <img src={InTransportIcon} alt="In Transport" />;
  }

  return <img src={ParkingIcon} alt="Parking" />;
}
